/**
 * Layout: Password
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the product template.
 *
 */
import '@/styles/theme.scss';

/**
 * Password helpers.
 */
import EventBus from '~/helpers/event-bus';

/**
 * Password component imports.
 */
import Toggle from '~/components/toggle';

/**
 * Frame utils.
 */
window.Frame = window.Frame || {};
window.Frame.EventBus = EventBus();

document.addEventListener('DOMContentLoaded', () => {

  /**
   * Instantiate password form toggle.
   */
  const FormToggle = Toggle({
    toggleSelector: 'loginFormToggle',
    overlay: false,
  });

  FormToggle.init();
});
